import React, { useState, useRef, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createCompanyJobDescription, createSpotJD } from "../../graphql/mutations";
import Header from "../header/Header";
import { useNavigate } from "react-router-dom";
import { listCompanyJobDescriptions } from "../../graphql/queries";

const JobDetails = () => {
  const [jobTitle, setJobTitle] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedExperience, setSelectedExperience] = useState("");
  const [skill, setSkill] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [compensation, setCompensation] = useState("");
  const [benefits, setBenefits] = useState("");
  const navigate = useNavigate();
  const CompanyEmailID = localStorage.getItem("CompanyEmailID");
  const [workMode, setWorkMode] = useState("");

  const compensationRef = useRef(null);
  const [companyjobcount, setcompanyjobcount] = useState(false);

  // fetching companyjodescription count

  useEffect(() => {
    const fetchJobCount = async () => {
      const storedCompanyID = localStorage.getItem("CompanyProfileID");

      try {
        let nextToken = null;
        let jobCount = 0;

        do {
          const jobListResponse = await API.graphql(
            graphqlOperation(listCompanyJobDescriptions, {
              filter: { companyProfileID: { eq: storedCompanyID } },
              limit: 100,
              nextToken: nextToken,
            })
          );

          const jobDescriptions =
            jobListResponse.data.listCompanyJobDescriptions.items;
          jobCount += jobDescriptions.length;

          nextToken = jobListResponse.data.listCompanyJobDescriptions.nextToken;
        } while (nextToken);

        // Set company count
        if (jobCount > 0) {
          // You can set company job count here
          setcompanyjobcount(true);
        } else {
          console.log("No job descriptions found for the company.");
          setcompanyjobcount(false);
        }
      } catch (error) {
        console.error("Error fetching job count:", error);
        // Handle error appropriately
      }
    };

    fetchJobCount();
  }, []);

  console.log(
    "$$$$$$$$$$$$$$$$$$$$$$$$$@@@@@@@@@@@@@@@@@@@@@@@@@@",
    companyjobcount
  );

  const handleCompensationClick = () => {
    compensationRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all mandatory fields are filled out
    if (
      !jobTitle ||
      !selectedCategory ||
      !selectedExperience ||
      !skill ||
      !jobDescription ||
      !compensation ||
      !benefits ||
      !workMode // Check if work mode is selected
    ) {
      alert("Please fill out all mandatory fields.");
      return;
    }

    try {
      const response = await API.graphql({
        query: createCompanyJobDescription,
        variables: {
          input: {
            jobTitle,
            selectedCategory,
            selectedExperience,
            skill,
            jobDescription,
            compensation,
            benefits,
            workMode, // Include work mode in the variables
            companyProfileID: localStorage.getItem("CompanyProfileID"),
            jobIDNo: 45, // Pass the actual value of jobIDNo variable here
          },
        },
      });

      if (response.errors && response.errors.length > 0) {
        console.error("Error submitting job details:", response.errors);
        // Show error message or handle the errors accordingly
      } else {
        console.log("Job details submitted successfully:", response);

        // Also create the paired SpotJD record so the Match button and
        // knowledge-graph sync features work for this job from day 1.
        // Failure here must NOT block job creation — the lazy fallback in
        // JobDetailsList will create one on first Match click if this fails.
        try {
          const newJob = response.data?.createCompanyJobDescription;
          if (newJob?.id) {
            const spotJDResp = await API.graphql(
              graphqlOperation(createSpotJD, {
                input: {
                  companyJobDescriptionID: newJob.id,
                  companyEmail: CompanyEmailID || "",
                  jdName: jobTitle,
                  skills: skill,
                  workMode: workMode,
                  workCategory: selectedCategory,
                  jobDescription: jobDescription,
                  filterCandidate: JSON.stringify([]),
                  selectedCandidate: JSON.stringify([]),
                },
              })
            );
            const newSpotJD = spotJDResp?.data?.createSpotJD;
            console.log("✅ Paired SpotJD created for new job:", newJob.id);

            // Register the new SpotJD with the JD parser so the matching engine
            // can find it. We AWAIT this so the job is guaranteed matchable by
            // the time the user lands on the job list. Adds a few seconds to
            // job creation but ensures Match works reliably for every new job.
            // A parser failure is logged but does not abort job creation.
            if (newSpotJD?.id) {
              try {
                const parserResp = await fetch(
                  "https://phone.getscreened.in/jdparser",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: newSpotJD.id }),
                  }
                );
                if (!parserResp.ok) {
                  console.warn(
                    "⚠️ JD parser returned non-OK status:",
                    parserResp.status
                  );
                } else {
                  console.log("✅ JD parser registered new SpotJD");
                }
              } catch (parserErr) {
                console.warn(
                  "⚠️ JD parser call failed; Match may not work for this job until the parser is reachable:",
                  parserErr
                );
              }
            }
          }
        } catch (spotJDError) {
          console.error(
            "⚠️ Job was created but paired SpotJD creation failed; lazy fallback will handle it on first Match click:",
            spotJDError
          );
        }

        // Reset form
        setJobTitle("");
        setSelectedCategory("");
        setSelectedExperience("");
        setSkill("");
        setJobDescription("");
        setCompensation("");
        setBenefits("");
        setWorkMode(""); // Reset work mode
      }
      navigate("/JobDetailsList");
    } catch (error) {
      console.error("Error submitting job details:", error);
      // Show error message
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleExperienceSelect = (experience) => {
    setSelectedExperience(experience);
  };

 

  const renderCategoryButtons = () => {
    const categories = [
      "Full-time",
      "Part-time",
      "Contract",
      "Temporary",
      "Internship",
    ];
    return categories.map((category, index) => (
      <button
        key={index}
        style={{
          padding: "6px 12px",
          backgroundColor:
            selectedCategory === category ? "rgba(139, 92, 246, 0.2)" : "rgba(17, 24, 39, 0.4)",
          borderRadius: "4px",
          cursor: "pointer",
          transition: "all 0.2s",
          color: selectedCategory === category ? "#A78BFA" : "#9CA3AF",
          border: selectedCategory === category ? "1px solid #8B5CF6" : "1px solid rgba(55, 65, 81, 1)",
          fontSize: "12px",
          fontWeight: "500"
        }}
        onClick={() => handleCategorySelect(category)}
      >
        {category}
      </button>
    ));
  };

  const renderExperienceButtons = () => {

    // original code start

    // const experienceLevels = [
    //   { label: "Fresher\nJust out of college", value: "Fresher" },
    //   { label: "Entry Level\n1-3 years", value: "Entry Level" },
    //   { label: "Mid Level\n3-5 years", value: "Mid Level" },
    //   { label: "Senior Level\n5+ years", value: "Senior Level" },
    // ];
    
    // original code end

    const experienceLevels = [
      { label: "Fresher\nJust out of college", value: "Fresher" },
      { label: "Entry Level\n1-3 years", value: "Entry Level 1-3 years" },
      { label: "Mid Level\n3-5 years", value: "Mid Level 3-5 years" },
      { label: "Senior Level\n5+ years", value: "Senior Level 5+ years" },
    ];

    return experienceLevels.map((experience, index) => (
      <button
        key={index}
        style={{
          backgroundColor:
            selectedExperience === experience.value ? "rgba(139, 92, 246, 0.2)" : "rgba(17, 24, 39, 0.4)",
          border: selectedExperience === experience.value ? "1px solid #8B5CF6" : "1px solid rgba(55, 65, 81, 1)",
          borderRadius: "4px",
          padding: "10px 8px",
          textAlign: "center",
          fontSize: "12px",
          cursor: "pointer",
          flex: "1",
          minWidth: "0",
          transition: "all 0.2s ease",
          color: selectedExperience === experience.value ? "#A78BFA" : "#9CA3AF",
          whiteSpace: "pre-line",
          fontWeight: "500"
        }}
        onClick={() => handleExperienceSelect(experience.value)}
      >
        {experience.label}
      </button>
    ));
  };


  const handleWorkModeSelect = (mode) => {
    setWorkMode(mode);
  };

  const renderWorkModeOptions = () => {
    const workModes = ["Work from home", "Remote", "Work from office"];

    return workModes.map((mode, index) => (
      <button
        key={index}
        style={{
          padding: "6px 12px",
          backgroundColor: workMode === mode ? "rgba(139, 92, 246, 0.2)" : "rgba(17, 24, 39, 0.4)",
          borderRadius: "4px",
          cursor: "pointer",
          transition: "all 0.2s",
          color: workMode === mode ? "#A78BFA" : "#9CA3AF",
          border: workMode === mode ? "1px solid #8B5CF6" : "1px solid rgba(55, 65, 81, 1)",
          fontSize: "12px",
          fontWeight: "500"
        }}
        onClick={() => handleWorkModeSelect(mode)}
      >
        {mode}
      </button>
    ));
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#030712",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Sora', 'Inter', sans-serif"
    }}>
      {/* Aurora Background */}
      <div style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none"
      }}>
        <div style={{
          position: "absolute",
          top: "10%",
          left: "10%",
          width: "500px",
          height: "500px",
          background: "radial-gradient(circle, rgba(12, 74, 110, 0.25) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          animation: "aurora 60s ease-in-out infinite"
        }}></div>
        <div style={{
          position: "absolute",
          bottom: "10%",
          right: "10%",
          width: "600px",
          height: "600px",
          background: "radial-gradient(circle, rgba(67, 56, 202, 0.2) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          animation: "aurora 45s ease-in-out infinite reverse"
        }}></div>
      </div>
      
      <style>{`
        @keyframes aurora {
          0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.8; }
          25% { transform: translate(50px, 30px) scale(1.1); opacity: 0.6; }
          50% { transform: translate(-30px, 50px) scale(0.9); opacity: 0.9; }
          75% { transform: translate(30px, -40px) scale(1.05); opacity: 0.7; }
        }
      `}</style>

      <div style={{ position: "relative", zIndex: 1 }}>
        <Header />
      </div>

      <div style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "16px 20px",
        position: "relative",
        zIndex: 1
      }}>
        <div style={{
          background: "rgba(17, 24, 39, 0.5)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(55, 65, 81, 1)",
          borderRadius: "8px",
          padding: "20px",
          marginTop: "16px"
        }}>
          <h1 style={{
            color: "#F9FAFB",
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "24px",
            fontWeight: "600"
          }}>
            Create Your Job
          </h1>

        <div style={{ marginBottom: "12px" }}>
          <label
            htmlFor="job-title"
            style={{
              display: "block",
              color: "#F9FAFB",
              marginBottom: "6px",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Job Title
          </label>
          <input
            type="text"
            id="job-title"
            placeholder="Enter job title"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid rgba(55, 65, 81, 1)",
              borderRadius: "4px",
              backgroundColor: "rgba(17, 24, 39, 0.4)",
              color: "#F9FAFB",
              fontSize: "13px",
              outline: "none"
            }}
          />
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label
            htmlFor="job-search"
            style={{
              display: "block",
              color: "#F9FAFB",
              marginBottom: "6px",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Job Category
          </label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {renderCategoryButtons()}
          </div>
        </div>

        
        <div style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              color: "#F9FAFB",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Work Mode
          </label>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "6px"
            }}
          >
            {renderWorkModeOptions()}
          </div>
        </div>



        <div style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              color: "#F9FAFB",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Experience Level
          </label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "6px",
              flexWrap: "wrap"
            }}
          >
            {renderExperienceButtons()}
          </div>
        </div>

        <div style={{ marginBottom: "12px" }}>
          <label
            htmlFor="skill"
            style={{
              display: "block",
              color: "#F9FAFB",
              marginBottom: "6px",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Skill
          </label>
          <input
            type="text"
            id="skill"
            placeholder="Enter skills separated by comma"
            value={skill}
            onChange={(e) => setSkill(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid rgba(55, 65, 81, 1)",
              borderRadius: "4px",
              backgroundColor: "rgba(17, 24, 39, 0.4)",
              color: "#F9FAFB",
              fontSize: "13px",
              outline: "none"
            }}
          />
        </div>

        <div style={{ marginBottom: "12px" }}>
          <label
            htmlFor="job-description"
            style={{
              display: "block",
              color: "#F9FAFB",
              marginBottom: "6px",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            Job Description
          </label>
          <textarea
            id="job-description"
            placeholder="Enter job description"
            rows="4"
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid rgba(55, 65, 81, 1)",
              borderRadius: "4px",
              backgroundColor: "rgba(17, 24, 39, 0.4)",
              color: "#F9FAFB",
              fontSize: "13px",
              outline: "none",
              resize: "vertical"
            }}
          ></textarea>
        </div>

        {/* <button
        onClick={handleCompensationClick}
        style={{
          padding: "10px 15px",
          backgroundColor: "#9900ff",
          color: "#ffffff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        Compensation
      </button> */}

        <div ref={compensationRef}>
          <div style={{ marginBottom: "12px" }}>
            <label
              htmlFor="compensation"
              style={{
                display: "block",
                color: "#F9FAFB",
                marginBottom: "6px",
                fontSize: "13px",
                fontWeight: "500"
              }}
            >
              Compensation
            </label>
            <input
              type="text"
              id="compensation"
              placeholder="eg : 6LPA-12LPA"
              value={compensation}
              onChange={(e) => setCompensation(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                border: "1px solid rgba(55, 65, 81, 1)",
                borderRadius: "4px",
                backgroundColor: "rgba(17, 24, 39, 0.4)",
                color: "#F9FAFB",
                fontSize: "13px",
                outline: "none"
              }}
            />
          </div>

          <div style={{ marginBottom: "12px" }}>
            <label
              htmlFor="benefits"
              style={{
                display: "block",
                color: "#F9FAFB",
                marginBottom: "6px",
                fontSize: "13px",
                fontWeight: "500"
              }}
            >
              Benefits
            </label>
            <textarea
              id="benefits"
              placeholder="Enter benefits details"
              rows="4"
              value={benefits}
              onChange={(e) => setBenefits(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                border: "1px solid rgba(55, 65, 81, 1)",
                borderRadius: "4px",
                backgroundColor: "rgba(17, 24, 39, 0.4)",
                color: "#F9FAFB",
                fontSize: "13px",
                outline: "none",
                resize: "vertical"
              }}
            ></textarea>
          </div>

          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <button
              type="button"
              onClick={() => {
                // Handle cancel action
                navigate("/JobDetailsList"); // Navigate to JobDetailsList
              }}
              style={{
                padding: "7px 14px",
                marginLeft: "8px",
                backgroundColor: "rgba(239, 68, 68, 0.1)",
                color: "#F87171",
                border: "1px solid #EF4444",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "500",
                transition: "all 0.2s"
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(239, 68, 68, 0.2)"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239, 68, 68, 0.1)"}
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                padding: "7px 14px",
                marginLeft: "8px",
                backgroundColor: "rgba(34, 197, 94, 0.1)",
                color: "#4ADE80",
                border: "1px solid #22C55E",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "500",
                transition: "all 0.2s"
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(34, 197, 94, 0.2)"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(34, 197, 94, 0.1)"}
            >
              Submit
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};
export default JobDetails;
